'use client'

import { useFakeProgress } from '@/lib/hooks/useFakeProgress'
import { useId } from 'react'
import type { DropZoneStatus } from '../_components/DropZoneField.client'

function resolveDropZoneStatus({
  isDisabled,
  isLoading,
  hasError,
}: {
  isDisabled?: boolean
  isLoading?: boolean
  hasError: boolean
}): DropZoneStatus {
  if (isDisabled) return 'disabled'
  if (isLoading) return 'progress'
  if (hasError) return 'error'

  return 'default'
}

type UseDropZoneFieldStateParams = {
  isLoading?: boolean
  isDisabled?: boolean
  errorMessage?: string
}

export function useDropZoneFieldState({
  isLoading,
  isDisabled,
  errorMessage,
}: UseDropZoneFieldStateParams) {
  const fakeProgress = useFakeProgress(!!isLoading)
  const isFieldDisabled = !!isDisabled || fakeProgress.blocksInteraction
  const hasError = !!errorMessage
  const shouldDisplayError = !fakeProgress.showProgress && !isDisabled && hasError
  const inputId = useId()
  const errorId: string | false = shouldDisplayError ? `${inputId}-error` : false
  const labelId = `${inputId}-label`
  const status = resolveDropZoneStatus({
    isDisabled,
    isLoading: fakeProgress.showProgress,
    hasError,
  })

  return {
    fakeProgress,
    isFieldDisabled,
    shouldDisplayError,
    errorId,
    labelId,
    status,
  }
}
